<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="角色名称"
                ><a-input v-model="queryParam.roleName" placeholder="角色名称"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="角色代码"
                ><a-input v-model="queryParam.roleCode"
              /></a-form-item>
            </a-col>
            <!-- <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="状态">
                  <a-select v-model="queryParam.sta" placeholder="请选择">
                    <a-select-option value="I">有效</a-select-option>
                    <a-select-option value="X">无效</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template> -->
            <a-col :md="8" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button
                  class="button-margin-left"
                  @click="() => (queryParam = { sta: 'I' })"
                  >重置</a-button
                >
                <a-button
                  type="primary"
                  icon="plus"
                  @click="showModal('add')"
                  v-hasAnyPermission="`role:add`"
                  class="button-margin-left"
                  >新建</a-button
                >

                <a-dropdown
                  class="button-margin-left"
                  v-hasAnyPermission="`role:delete`"
                >
                  <a-menu slot="overlay" @click="menuClick">
                    <a-menu-item key="1">
                      <a-icon type="delete" />
                      删除
                    </a-menu-item>
                  </a-menu>
                  <a-button style="margin-left: 8px">
                    批量操作
                    <a-icon type="down" />
                  </a-button>
                </a-dropdown>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <s-table
        ref="table"
        size="default"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
        :rowSelection="options.rowSelection"
      >
        <span slot="action" slot-scope="text, record">
          <template>
            <a
              class="a-action"
              @click="action(record, 'edit')"
              v-hasAnyPermission="`role:edit`"
              >编辑</a
            >
            <a-popconfirm
              title="确认删除?"
              @confirm="action(record, 'del')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`role:delete`"
              ><a class="a-action">删除</a></a-popconfirm
            >
          </template>
        </span>
      </s-table>
    </a-card>

    <!-- 弹出框 -->
    <a-modal
      v-model="modal.visible"
      :title="modal.title"
      @ok="handleOk"
      @cancel="cancel"
    >
      <a-form-model
        ref="ruleForm"
        :model="formData"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }"
      >
        <a-form-model-item label="角色名称" prop="roleName"
          ><a-input v-model="formData.roleName" :maxLength="20"
        /></a-form-model-item>
        <a-form-model-item label="描述" prop="roleDesc"
          ><a-input v-model="formData.roleDesc" type="textarea"
        /></a-form-model-item>
        <a-form-model-item label="菜单级别">
          <a-select
            v-model="formData.level"
            :disabled="modal.type == 'edit' ? true : false"
          >
            <a-select-option value="SYSTEM">系统级</a-select-option>
            <a-select-option value="BUSINESS">业务级</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="资源信息">
          <a-tree
            v-if="tree.data.length > 0"
            ref="myTree"
            checkable
            :tree-data="tree.data"
            :replace-fields="tree.replaceFields"
            v-model="tree.checkedKeys"
            :expanded-keys="tree.expandedKeys"
            @expand="onExpand"
            @check="onCheck"
          />
          <span v-else>暂无相关资源</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";

export default {
  name: "RoleList",
  components: {
    STable,
    PageView
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: "角色名称",
          dataIndex: "roleName"
        },
        {
          title: "角色代码",
          dataIndex: "roleCode"
        },
        // {
        //   title: "状态",
        //   dataIndex: "sta"
        // },
        {
          title: "描述",
          dataIndex: "roleDesc"
        },
        {
          title: "更新时间",
          dataIndex: "modifyDatetime"
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.systemBksApi
          .pageSystemRole(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      },
      selectedRowKeys: [],
      selectedRows: [],
      options: {
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      //弹出框参数
      modal: {
        visible: false,
        title: "",
        type: "add"
      },
      //form
      formData: {
        roleName: "",
        roleDesc: "",
        level: "SYSTEM",
        permCodes: "",
        halfChecked: ""
      },
      //form rules
      rules: {
        roleName: [
          {
            required: true,
            message: "请输入角色名称",
            trigger: "change"
          }
        ]
      },
      tree: {
        expand: false,
        data: [],
        replaceFields: {
          title: "permName",
          key: "permCode"
        },
        checkedKeys: [],
        expandedKeys: []
      }
    };
  },
  watch: {
    "formData.level"(val) {
      this.queryPermissions();
    }
  },
  created() {
    this.queryPermissions();
  },
  methods: {
    queryPermissions() {
      this.$http.systemBksApi
        .listPermission({ level: this.formData.level })
        .then(res => {
          this.tree.data = res.resultObject;
        });
    },
    findRolePerm(roleObject) {
      this.$http.systemBksApi
        .listRolePerm({ roleCode: roleObject.roleCode })
        .then(res => {
          let arr = res.resultObject;
          if (arr) {
            let halfCheck = roleObject.halfChecked.split(",");
            for (let code of halfCheck) {
              let index = arr.indexOf(code);
              arr.splice(index, 1);
            }
            this.tree.checkedKeys = arr;
          }
        });
    },
    action(record, type) {
      if (type == "edit") {
        this.showModal(type);
        this.formData = Object.assign({}, record);
        this.findRolePerm(record);
      } else if (type == "del") {
        this.$http.systemBksApi
          .removeSystemRole({ roleCodes: record.roleCode })
          .then(res => {
            if (res.result == 0) {
              this.$refs.table.refresh(true);
              this.$refs.table.clearSelected();
              this.$message.success(res.msg);
            }
          });
      }
    },
    showModal(type) {
      this.modal.visible = true;
      this.modal.title = type == "add" ? "添加资源" : "编辑资源";
      this.modal.type = type;
    },
    cancel() {
      this.tree.checkedKeys = [];
      this.tree.expandedKeys = [];
      this.$refs.ruleForm.resetFields();
      this.formData = {};
      this.formData.level = "SYSTEM";
    },
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = Object.assign({}, this.formData);
          let action = "";
          if (this.modal.type == "add") {
            action = "saveSystemRole";
          } else {
            action = "modifySystemRole";
          }
          this.$http.systemBksApi[action](param).then(r => {
            this.modal.visible = false;
            this.cancel();
            this.$refs.table.refresh(true);
            this.$message.success(r.msg);
          });
        }
      });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },

    menuClick(evt) {
      if (this.selectedRowKeys.length > 0) {
        let codes = "";
        for (let item of this.selectedRows) {
          codes += item.roleCode + ",";
        }
        this.$http.systemBksApi
          .removeSystemRole({ roleCodes: codes })
          .then(res => {
            if (res.result == 0) {
              this.$refs.table.refresh(true);
              this.$refs.table.clearSelected();
              this.$message.success(res.msg);
            }
          });
      } else {
        this.$message.info("请选择数据");
      }
    },

    onCheck(checkedKeys, info) {
      this.formData.permCodes = checkedKeys
        .concat(info.halfCheckedKeys)
        .join(",");
      this.formData.halfChecked = info.halfCheckedKeys.join(",");
    },
    onExpand(expandedKeys) {
      this.tree.expandedKeys = expandedKeys;
    }
  }
};
</script>
